import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_STATE_DROPDOWN = 'GET_STATE_DROPDOWN';
export const GET_STATE_DROPDOWN_SUCCESS = 'GET_STATE_DROPDOWN_SUCCESS';
export const GET_STATE_DROPDOWN_FAIL = 'GET_STATE_DROPDOWN_FAIL';
export const GET_STATE_DROPDOWN_RESET = 'GET_STATE_DROPDOWN_RESET';

export const getStateDropdown = (params) => {
	return {
		type: GET_STATE_DROPDOWN,
		params,
	};
};

export const getStateDropdownSuccess = (response) => {
	return {
		type: GET_STATE_DROPDOWN_SUCCESS,
		response,
	};
};

export const getStateDropdownFail = (response) => {
	return {
		type: GET_STATE_DROPDOWN_FAIL,
		response,
	};
};

export const getStateDropdownReset = () => {
	return {
		type: GET_STATE_DROPDOWN_RESET,
	};
};

export const getStateDropdownApi = (data) => {
	return (dispatch) => {
		dispatch(getStateDropdown());
		axios
			.get(`${config.api.base_url}/common/all-states`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getStateDropdownData = response.data;
				dispatch(getStateDropdownSuccess(getStateDropdownData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getStateDropdownFail(errorMsg));
			});
	};
};
